<template>
  <div class="nt-autocomplete2" ref="wrap">
    <slot name="preppend-button"></slot>
    <!-- Input -->
    <input type="text"
      :placeholder="placeholder"
      class="nt-autocomplete2__input"
      v-model.trim="text"
      @focus="open" @blur="close" @keydown="onKeyDown"
      :disabled="changed"
    />
    <slot name="append-button" :_changed="changed" :_reset="reset"></slot>
    <!-- Results
      v-if="opened"
      @mouseover="current = index"
    -->
    <div v-show="opened" ref="content" class="nt-autocomplete2__items">
      <div v-for="(item, index) in list" :key="item.id"
          ref="item"
          :class="{ 'current': index === current }"
          @mousedown="change(item.text)"
        >
        {{ item.text }}
      </div>
    </div>
  </div>
</template>

<script>
import qs from 'qs'
import _ from 'lodash'
import axios from 'axios'

export default {
  name: 'nt-autocomplete2',
  props: {
    url: {
      type: String,
      default: 'http://web.api/api/Resources/Autocomplete',
    },
    placeholder: {
      type: String,
      default: '',
    },
    selected: {
      type: String,
      default: null,
    },
  },
  watch: {
    /*eslint-disable*/
    text: _.debounce(function(val) {
      this.getData(val);
    }, 500),
    selected(val) {
      this.text = val
    },
    opened() {
      this.current = -1
    }
  },
  data() {
    return {
      text: '',
      opened: false,
      list: [],
      current: -1
    };
  },
  computed: {
    changed() {
      return !!this.selected
    }
  },
  created() {
    if (!this.selected) return

    this.text = this.selected
  },
  updated() {
    this.$nextTick(() => {
      this.showIn()
    })
  },
  methods: {
    showIn() {
      const { wrap, content } = this.$refs
      const formBounds = wrap.getBoundingClientRect()
      const resultsBounds = content.getBoundingClientRect()

      const positionY = window.innerHeight - formBounds.top - 140
      const size = resultsBounds.height + formBounds.height

      if ((size > positionY) && (resultsBounds.height < formBounds.top)) {
        content.style.top = `-${content.clientHeight}px`
      } else {
        content.style.top = null
      }
    },
    // getText(val) {
    //   return val.toLowerCase() !== this.text.toLowerCase() && this.list.length > 1
    // },
    getData(val) {
      axios.get(this.url, {
        params: {
          author: val,
        },
        paramsSerializer: params => {
          return qs.stringify(params)
        },
      }).then((resp) => {
        this.list = this.normalizeData(resp.data);
      });
    },
    normalizeData(data) {
      if (!data) return []

      return _.reduce(data, (memo, item) => {
        const transform = _.mapKeys(item, (v, k) => k.toLowerCase());
        // _.transform(item, (result, val, key) => result[key.toLowerCase()] = val)
        return memo.push(transform), memo
      }, [])
    },
    open() {
      this.opened = true;
    },
    close() {
      this.opened = false;
    },
    onKeyDown(event) {
      switch (event.keyCode) {
        case 13:
          this.onEnter()
          break;
        case 38:
          this.moveToUp()
          break;
        case 40:
          this.moveToDown()
          break;
        default:
          break;
      }
    },
    onEnter() {
      if (this.current < 0) return

      const value = this.list[this.current].text
      this.current = -1

      this.change(value)
    },
    moveToUp() {
      const { content, item } = this.$refs
      const curr = this.current - 1

      if (curr >= -1) {
        this.current--
      } else {
        this.current = this.list.length - 1
      }

      const element = item[this.current]

      if (element) {
        content.scrollTop = element.offsetTop
      }
    },
    moveToDown() {
      const { content, item } = this.$refs
      const curr = this.current + 1
      const limit = this.list.length - 1

      if (curr <= limit) {
        this.current = curr
      } else {
        this.current = -1
      }

      const element = item[this.current]

      if (element) {
        content.scrollTop = element.offsetTop
      }
    },
    // onmouseover(val) {
    //   this.current = val
    // },
    reset() {
      this.change('');
    },
    change(val) {
      this.close()
      this.text = val
      this.$emit('changed', this.text)
    }
  },
};
</script>

<style scoped lang="scss">
  .nt-autocomplete2 {
    width: 100%;
    position: relative;
    display: flex;
    // margin: 0 10px 10px 0;
    padding: 12px;
    letter-spacing: -0.5px;
    background-color: #4e4e4e;
    border-radius: 4px;

    svg {
      width: 18px;
      height: 18px;
      fill: #999999;
      color: #999999;

      &.close {
        &:hover {
          cursor: pointer;
        }
      }
    }

    &__input {
      flex: 1;
      padding: 0;
      border: 0;
      font-size: 16px;
      outline: none;
      color: #e0dbd7;
      background: none;

      &::placeholder {
        color: #999999;
      }

      &::-ms-clear {
        display: none;
      }
    }

    &__items {
      position: absolute;
      z-index: 50;
      top: 100%;
      left: 0;
      right: 0;
      background-color: #4e4e4e;
      max-height: 450px;
      overflow-y: auto;

      &::-webkit-scrollbar-track {
        // border: 1px solid #eee;
        padding: 2px 0;
        // background-color: #FFF;
        background-color: #999;
      }
      &::-webkit-scrollbar {
        width: 10px;
      }
      &::-webkit-scrollbar-thumb {
        border-radius: 10px;
        // box-shadow: inset 0 0 6px rgba(0,0,0,.3);
        background-color: #1d2822;
        // border: 1px solid #3b3b3b;
      }

      & div {
        color: #dbdbdb;
        text-align: left;
        padding: 16px 20px;

        &:not(:last-child) {
          // border-bottom: 1px solid rgb(238, 238, 238);
        }

        &:hover {
          cursor: pointer;
          // background-color: #eee;
          background-color: #999;
        }

        &.current {
          background-color: #999;
        }
      }
    }
  }
</style>
